<template>
  <section id="subteams">
    <div class="subteams-wrapper">
      <h2 id="our-subteams"><a href="#our-subteams" class="header-link">Our Sub-teams</a></h2>
      <div class="subteam-display">
        <SubteamTile v-for="(subteam, index) in subteams" :key="index" :data="subteam"/>
      </div>
    </div>
  </section>
</template>

<script>
import SubteamTile from "@/components/SubteamTile.vue";

export default {
  name: "SubteamsView",
  components: {
    SubteamTile,
  },
  computed: {
    subteams() {
      return this.$store.state.subteams;
    }
  }
}
</script>

<style lang="scss">
.subteams-wrapper {
  position: relative;
  background-color: var(--white);
  padding: var(--section-padding);
  padding-top: 1em;
  padding-bottom: 1em;
  max-width: var(--max-width);
  margin: 0 auto;
  height: 100%;

  h2 {
    color: var(--medium);
    margin-bottom: 2rem;
  }

  .subteam-display {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: var(--grid-gap-desktop, 2.5rem);
    width: 100%;
    align-items: stretch;
  }
}

@media screen and (max-width: 860px) {
  .subteams-wrapper {
    padding-left: var(--section-padding-mobile, 6%);
    padding-right: var(--section-padding-mobile, 6%);
    padding-top: 1em;
    padding-bottom: 2em;

    h2 {
      margin-bottom: 1.5rem;
    }

    .subteam-display {
      grid-template-columns: 1fr;
      gap: var(--grid-gap-mobile, 1.5rem);
    }
  }
}
</style>
